import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button/Button";

export function BusinessCard({}) {
  const navigate = useNavigate();

  return (
    <div>
      <Button onClick={() => navigate("/about")} />
    </div>
  );
}
